<template>
  <a
    v-if="supportTelegramUrl"
    :href="supportTelegramUrl"
    :aria-label="$t('common.support')"
    :title="$t('common.support')"
    target="_blank"
    rel="noopener noreferrer"
    class="support-contact"
    :class="{ 'support-contact--floating': floating }"
  >
    <van-icon v-if="floating" name="service-o" aria-hidden="true" />
    <van-cell v-else :title="$t('common.support')" :label="$t('common.supportTelegram')" icon="service-o" is-link />
  </a>
  <button
    v-else-if="floating && failed && !loading"
    type="button"
    class="support-contact support-contact--floating"
    :aria-label="$t('common.supportLoadFailed')"
    :title="$t('common.supportLoadFailed')"
    @click="retry"
  >
    <van-icon name="service-o" aria-hidden="true" />
  </button>
  <van-cell
    v-else-if="!floating"
    :title="$t('common.support')"
    :label="$t(loading ? 'common.supportLoading' : failed ? 'common.supportLoadFailed' : 'common.supportPending')"
    icon="service-o"
    :is-link="failed"
    :clickable="failed && !loading"
    @click="retry"
  />
</template>

<script>
import { getRates } from '../api/crowd';

export default {
  name: 'SupportContact',
  props: {
    floating: { type: Boolean, default: false }
  },
  data() {
    return { supportTelegramUrl: '', loading: true, failed: false };
  },
  created() {
    return this.loadSupport();
  },
  methods: {
    async loadSupport() {
      this.loading = true;
      this.failed = false;
      this.supportTelegramUrl = '';
      try {
        const config = await getRates();
        const url = typeof config.supportTelegramUrl === 'string' ? config.supportTelegramUrl.trim() : '';
        if (url.length <= 512 && /^https:\/\/t\.me\/(?:[A-Za-z0-9_]+|\+[A-Za-z0-9_-]+|joinchat\/[A-Za-z0-9_-]+)\/?$/.test(url)) {
          this.supportTelegramUrl = url;
        }
      } catch {
        this.failed = true;
      } finally {
        this.loading = false;
      }
    },
    retry() {
      if (this.failed && !this.loading) return this.loadSupport();
    }
  }
};
</script>

<style scoped>
.support-contact {
  display: block;
  color: inherit;
  text-decoration: none;
}

.support-contact--floating {
  position: fixed;
  right: calc(16px + env(safe-area-inset-right, 0px));
  bottom: calc(72px + env(safe-area-inset-bottom, 0px));
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 0;
  border: 2px solid #fff;
  border-radius: 50%;
  color: #fff;
  background: var(--green, #0f7b63);
  box-shadow: 0 4px 14px rgba(10, 97, 78, 0.25);
  font-size: 24px;
  cursor: pointer;
}

.support-contact--floating:focus-visible {
  outline: 3px solid var(--green-dark, #0a614e);
  outline-offset: 3px;
}

@media (min-width: 1024px) {
  .support-contact--floating {
    right: 24px;
    bottom: 24px;
  }
}
</style>
